<template>
  <div class="bg">
    <div class="login-box">
      <div class="base-header login-header">
        <van-icon name="cross" size="30" color="#fff" style="margin: 10px" />
        <van-popover class="lang-btn"
          v-model="showPopover"
          trigger="click"
          :actions="langlst"
        >
        <ul>
            <li
              @click="changeLang(item)"
              v-for="(item, index) in langlst"
              :key="index"
              class="lang-item-box"
            >
              <div style="float: left; height: 30px; line-height: 30px">
                {{ item.language_name }}
              </div>
            </li>
          </ul>
          <template #reference>
            <div>
              {{ getlangName(lang) }}
            </div>
          </template>
        </van-popover>
        <div class="register-btn" @click="$router.push({name:'register'})">{{ $t("login.register") }}</div>
      </div>
      
      <div class="frm-login">
        <div style="width: 240px;margin: 10px auto;"><img :src="$store.getters.getBaseInfo.ico" style="width: 100%;" /></div>
        <van-form @submit="onSubmit">
          <div class="item">
            <van-field
              v-model="username"
              :placeholder="$t('login.nameple')"
              @input="inputChange"
              :rules="[{ required: true }]"
            >
              <template #left-icon>
                <van-icon name="contact" color="rgb(153,153,153)" size="24" />
              </template>
            </van-field>
          </div>
          <div class="item">
            <van-field
              v-model="password"
              :type="isshowpwd ? 'text' : 'password'"
              :placeholder="$t('login.pwdple')"
              @input="inputChange"
              :rules="[{ required: true }]"
            >
              <template #left-icon>
                <van-icon name="lock" color="rgb(153,153,153)" size="24" />
              </template>
              <template #right-icon>
                <van-icon
                  :name="isshowpwd ? 'eye-o' : 'closed-eye'"
                  color="rgb(153,153,153)"
                  size="24"
                  @click="isshowpwd = !isshowpwd"
                />
              </template>
            </van-field>
          </div>
          <div style="margin: 25px 16px; color: #fff">
            {{ $t("login.tips") }}
          </div>
          <div style="margin: 16px">
            <van-button
              native-type="submit"
              :class="istopost ? 'btn' : 'no-btn'"
              >{{ $t("login.login") }}</van-button
            >
          </div>
        </van-form>
      </div>
    </div>
  </div>
</template>

<script>
import { TokenLangKey, setTokenbyName, getTokenbyName } from "@/utils/cookies";
export default {
  name: "LoginView",
  data() {
    return {
      username: null,
      password: null,
      isshowpwd: false,
      istopost: false,
      ispost: false,
      lang: null,
      langlst: [
        { language_name: "English", file_name: "en_us" }, //英语
        { language_name: "हिंदी", file_name: "hi_hi" }, //"印地"
      ],
      showPopover:false
    };
  },
  mounted(){
    this.lang = getTokenbyName(TokenLangKey);
    if(!this.lang) this.lang = 'en_us'
  },
  methods: {
    getlangName(val) {
      let reuslt = val;
      this.langlst.forEach((item) => {
        if (val == item.file_name) {
          reuslt = item.language_name;
        }
      });
      return reuslt;
    },
    inputChange() {
      this.istopost =
        this.username &&
        this.username.length > 0 &&
        this.password &&
        this.password.length > 0;
    },
    changeLang(item){
        this.showPopover = false;
        this.lang = item.file_name
        setTokenbyName(TokenLangKey, item.file_name);
        location.reload();
    },
    async onSubmit() {
      if (!this.istopost) return;
      await this.$http({
        url: "member_login",
        method: "post",
        data: {
          username: this.username,
          password: this.password,
          lang: this.lang,
        },
      }).then((res) => {
        if (res.code === 200) {
          console.info(res.msg);
          this.$toast.success(res.msg);
          localStorage.setItem("token", res.data.id);
          this.$router.push("Mine");
        } else {
          this.$toast(res.msg);
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.bg {
  background-image: linear-gradient(180deg, #f560cd, #4f2b8a);
  .login-box {
    width: 100%;
    height: 100%;
    // background: url("../../assets/img/bg-login.png") no-repeat 50% / 100%;
    background-position: 72% 50px;
    .login-header {
      .register-btn {
        float: right;
        text-align: center;
        color: #fff;
        line-height: 50px;
        top: 0px;
        z-index: 999;
      }
      .lang-btn {
        float: right;
        text-align: center;
        color: #fff;
        border-radius: 10px;
        border: 1px solid #fff;
        height: 30px;
        line-height: 30px;
        padding: 0px 10px;
        margin: 10px 10px;
        
      }
    }
  }
  .frm-login {
    padding-top: 170px;
    .item {
      margin: 16px;
    }
  }
}
.lang-item-box {
            padding:8px 14px;
        }
</style>
<style lang="scss">
.bg {
  .frm-login {
    .item {
      .van-cell {
        background-color: rgb(255, 255, 255, 0.8) !important;
        border-radius: 8px;
        border: 1px solid #a253d0;
        line-height: 30px !important;
      }
    }
  }
}
</style>
